import React, { Fragment, useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { APIContext } from "../../Contexts/APIContext";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import AgentViewModel from "../ViewModels/AgentViewModel";
import TextField from "@mui/material/TextField";
import FeedbackTabButtonsViewModel from "../ViewModels/FeedbackTabButtonsViewModel";

interface IProps {
    feedback: FeedbackTabButtonsViewModel
    fetchThenUpdate: (controllerAction: string) => void
    allTeamLeaderQuestionsAnswered: boolean
    releaseToSelectedAgent: (completeId: number, payrollNumber: number) => void;
}

export default function TeamLeaderFeedbackTabButtons(props: IProps) {
    const { get, loading } = useContext(APIContext);
    const [agents, setAgents] = useState<AgentViewModel[]>([]);
    const [selectedAgent, setSelectedAgent] = useState<AgentViewModel | null>(null);

    useEffect(() => {
        if (props.feedback.scorecardType === "Redress") {
            var currentAgent = new AgentViewModel;
            currentAgent = {
                userName: props.feedback.agentName,
                payrollNumber: props.feedback.agentPayroll
            }
            setSelectedAgent(currentAgent);
            get('Feedback', `GetAgents?client=${props.feedback.client}`, (data) => setAgents(data));
        }
    }, [])

    const feedbackChallengeable = (feedbackStatus: string) => {
        return feedbackStatus === 'Awaiting Feedback'
            || feedbackStatus === 'Pending'
    }

    const onAgentSelect = (event: any, value: AgentViewModel) => {
        setSelectedAgent(value);
    }

    const releaseAgentFeedback = () => {
        if (props.feedback.scorecardType === "Redress") {
            if (selectedAgent) {
                props.releaseToSelectedAgent(props.feedback.completeId, selectedAgent.payrollNumber);
            }
        }
        else {
            props.fetchThenUpdate('ReleaseAgentFeedback');
        }
    }

    return (
        !loading ?
            <Fragment>
                {
                    props.feedback.status === "QA Approval Required" &&
                    <Grid size={12}>
                        <Typography
                            align='center'
                            color='secondary'
                            padding={1}
                            sx={{ border: 1, borderColor: 'secondary', borderRadius: 1, textTransform: 'uppercase' }}>
                            Feedback cannot be released until approved by a QA
                        </Typography>
                    </Grid>
                }
                {
                    props.feedback.status === 'Pending' &&
                    <Fragment>
                        {
                            props.feedback.scorecardType === "Redress" && agents.length > 0 &&
                            <Grid size={12}>
                                <Autocomplete
                                    options={agents}
                                    defaultValue={agents.find(agent => agent.payrollNumber === props.feedback.agentPayroll)}
                                    getOptionLabel={(agent) => agent.userName}
                                    onChange={onAgentSelect}
                                    renderInput={(params) => <TextField {...params} label="Select agent" />}
                                />
                            </Grid>
                        }
                        <Grid size={12}>
                            <Button
                                disabled={
                                    loading
                                    || (!props.feedback.active && (props.feedback.scorecardType === "Redress" && !selectedAgent))
                                }
                                variant='contained'
                                color='primary'
                                fullWidth
                                onClick={releaseAgentFeedback}>
                                Release feedback to agent
                            </Button>
                        </Grid>
                    </Fragment>
                }
                {
                    props.feedback.status === 'Awaiting Feedback' &&
                    <Fragment>
                        <Grid size={12}>
                            {
                                props.feedback.dateAgentResponded ?
                                    <Button
                                        disabled={loading || !props.allTeamLeaderQuestionsAnswered}
                                        variant='contained'
                                        color='primary'
                                        fullWidth
                                        onClick={() => props.fetchThenUpdate('TeamLeaderAcceptFeedback')}>
                                        Accept feedback
                                    </Button>
                                    :
                                    <Typography
                                        align='center'
                                        color='secondary'
                                        padding={1}
                                        sx={{ border: 1, borderColor: 'secondary', borderRadius: 1, textTransform: 'uppercase' }}>
                                        Agent must acknowledge feedback before it can be accepted
                                    </Typography>
                            }
                        </Grid>
                    </Fragment>
                }
                {
                    feedbackChallengeable(props.feedback.status) &&
                    <Grid size={12}>
                        <Button
                            disabled={loading}
                            variant='contained'
                            color='secondary'
                            fullWidth
                            onClick={() => props.fetchThenUpdate('TeamLeaderChallengeFeedback')}>
                            Challenge feedback
                        </Button>
                    </Grid>
                }
                {
                    props.feedback.status === 'Feedback Accepted' &&
                    <Grid size={12} >
                        <Typography
                            align='center'
                            color='primary'
                            padding={1}
                            sx={{ border: 1, borderColor: 'primary', borderRadius: 1, textTransform: 'uppercase' }}>
                            Feedback Accepted
                        </Typography>
                    </Grid>
                }
            </Fragment>
            :
            <Grid container justifyContent="center" alignItems="center" marginTop={2}>
                <Grid>
                    <CircularProgress />
                </Grid>
            </Grid>
    );
}